<template>
  <v-col
    cols="12"
    class="list-filters"
    :class="{ 'list-filters--advanced': !!$slots.advanced }"
  >
    <div
      v-if="$slots.advanced"
      class="list-filters__advanced"
    >
      <slot name="advanced" />
    </div>
    <div class="list-filters__fields">
      <slot />
    </div>
    <div
      v-if="$slots.period"
      class="list-filters__period"
      role="group"
      aria-label="Período"
    >
      <slot name="period" />
    </div>
  </v-col>
</template>

<script>
  export default {
    name: 'ListFilters',
  }
</script>

<style lang="scss">
.list-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  &__advanced {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
  }

  &__fields {
    display: flex;
    flex: 1 1 240px;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-width: 0;

    > * {
      flex: 1 1 180px;
      min-width: 0;
    }
  }

  &__period {
    display: grid;
    grid-template-columns: 40px minmax(0, 1.3fr) minmax(0, 1fr) 40px;
    align-items: center;
    gap: 4px;
    flex: 1 1 360px;
    max-width: 520px;
    min-width: 0;

    > * {
      min-width: 0 !important;
      max-width: none !important;
      margin: 0 !important;
    }
  }
}

@media (max-width: 959px) {
  .list-filters {
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 8px;
    padding: 12px 0;

    &__advanced {
      grid-column: 1;
      grid-row: 1;

      .v-btn {
        margin: 0 !important;
      }
    }

    &__fields {
      display: contents;

      > * {
        grid-column: 1 / -1;
        width: 100%;
        min-width: 0 !important;
        max-width: none !important;
        margin: 0 !important;
      }
    }

    &--advanced &__fields > :first-child {
      grid-column: 2;
      grid-row: 1;
    }

    &__period {
      grid-column: 1 / -1;
      grid-template-columns: 32px minmax(0, 1.3fr) minmax(0, 1fr) 32px;
      width: 100%;
      max-width: none;

      > .v-btn {
        width: 32px;
        height: 44px;
      }

      .v-input__prepend-inner {
        display: none;
      }
    }
  }
}

@media (max-width: 599px) {
  .list-filters__period {
    grid-template-columns: 40px minmax(0, 1fr) 40px;

    > :first-child {
      grid-column: 1;
      grid-row: 1 / 3;
    }

    > :nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }

    > :nth-child(3) {
      grid-column: 2;
      grid-row: 2;
    }

    > :last-child {
      grid-column: 3;
      grid-row: 1 / 3;
    }
  }
}
</style>
